import React from 'react'
import { Link } from 'react-router-dom'
import { getFestivals } from '../../data/loadData'
import './Header.css'

const edition = (name) => {
    const match = String(name || '').match(/^(\d+)\./)
    return match ? match[1] : ''
}

export default function Header() {
    const festivals = [...getFestivals()].reverse()
    const latestId = festivals.length ? festivals[0].id : null
    const firstYear = festivals.length ? festivals[festivals.length - 1].id : ''

    return (
        <header id="header" className="header header-transparent">
            <div className="container">
                <nav className="navbar navbar-expand-lg navbar-light">

                    <Link className="navbar-brand" to="/">
                        <img src="logo.png" alt="" style={{ height: "59px" }} />
                    </Link>
                    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown"
                        aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"><i className="icon icon-menu"></i></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarNavDropdown">
                        <ul className="navbar-nav">

                            <li className="nav-item">
                                <Link to="/about">HAKKIMIZDA</Link>
                            </li>

                            <li className="nav-item dropdown">
                                <Link to="#" className="" data-toggle="dropdown">FESTİVALLER <i className="fa fa-angle-down"></i></Link>
                                <div className="dropdown-menu festival-menu" lang="tr">
                                    <div className="festival-menu-head">
                                        <span className="festival-menu-title">Ethos Ankara Tiyatro Festivali</span>
                                        <span className="festival-menu-meta">{festivals.length} festival · {firstYear}–{latestId}</span>
                                    </div>
                                    <ul className="festival-menu-grid">
                                        {festivals.map((festival) => (
                                            <li key={festival.id} className={festival.id === latestId ? 'is-latest' : undefined}>
                                                <Link to={`/festival?f=${festival.id}`} aria-label={festival.name}>
                                                    <span className="festival-menu-num">{edition(festival.name)}.</span>
                                                    <span className="festival-menu-info">
                                                        <span className="festival-menu-year">{festival.id}</span>
                                                        {festival.theme ? <span className="festival-menu-theme">{festival.theme}</span> : null}
                                                    </span>
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </li>
                            <li className="nav-item">
                                <Link to="/tod">TÖD</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/award">ÖDÜLLER</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/press">BASINDA</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/contact">İletişim</Link>
                            </li>
                            <li className="header-ticket nav-item">

                                {
                                    //   <Link className="ticket-btn btn" to="/">Topluluk Başvuru</Link>
                                }



                            </li>
                        </ul>
                    </div>
                </nav>
            </div>
        </header>
    )
}
